import { generatePath, useParams, useNavigate as useNavigateRouter } from 'react-router-dom';

import { OwnerParams } from 'shared/types';
import { useCallback } from 'react';

export const useNavigate = (backPath: string): VoidFunction => {
  const params = useParams<OwnerParams>();
  const navigate = useNavigateRouter();

  return useCallback(() => {
    navigate(generatePath(backPath, { ...params }));
  }, [navigate, params, backPath]);
};
